import _styled from "styled-components";
import { AnimatePresence, m } from "framer-motion";
type Props = {
  show: boolean;
};
export function DeepDiveGalleryBlur(props: Props) {
  const {
    show
  } = props;
  return <AnimatePresence>
      {show && <_StyledMDiv initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      ease: "easeInOut",
      duration: 0.25
    }} />}
    </AnimatePresence>;
}
var _StyledMDiv = /*#__PURE__*/_styled(m.div).withConfig({
  displayName: "deep-dive-gallery-blur___StyledMDiv",
  componentId: "sc-1mtc0w9-0"
})({
  "position": "absolute",
  "inset": "0",
  "zIndex": "10",
  "--tw-backdrop-blur": "blur(12px)",
  "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
});